import { IForm } from 'core-components/classes/models/IForm'
import { Rest } from 'core/classes/http'

import { REQUEST_TIMEOUT_MS } from './requestTimeout'

export interface IRestError extends Error {
  status?: number
  responseBody?: unknown
}

interface IRestCallArgs {
  method: 'get' | 'post' | 'put' | 'delete'
  url: string
  payload?: IForm
}

export const restErrorStatus = (e: unknown): number | undefined =>
  e instanceof Error ? (e as IRestError).status : undefined

export const restErrorBody = <T>(e: unknown): T | undefined =>
  e instanceof Error ? ((e as IRestError).responseBody as T | undefined) : undefined

export async function restCall<T>({ method, url, payload }: IRestCallArgs): Promise<T> {
  const abortController = new AbortController()
  const timeoutId = setTimeout(() => abortController.abort(), REQUEST_TIMEOUT_MS)

  try {
    const result = await Rest[method]({ url, payload, signal: abortController.signal })

    if (result === null || result === undefined) {
      throw new Error('The request did not reach the service')
    }

    return result as T
  } finally {
    clearTimeout(timeoutId)
  }
}
